import React,{useState,useEffect} from 'react'
import Paging from './Paging'
import { Link } from 'react-router-dom'
function Favourites() {
const [curGenre,setcurGenre]=useState("All Genres")
const [favourites,setfavourites]=useState([])
const [genres,setGenres]=useState([])
const [rating,setRatng] =useState(0)
const [detail,setdetail] =useState([])
const [popularity,setPopularity] =useState(0)
const [search,setSearch] = useState("")
const [rows,setRows] =useState(5)
const [curpage,setCurpage]=useState(1)
 let genreids={
    28:'Action', 12:'Adventure',16:'Animation',35:'Comedy',80:'Crime',99:'Documentary',18:'Drama',10751:'Family',
    14:'Fantasy',36:'History',27:'Horror',10402:'Music',9648:'Mystery',10749:'Romance',878:'Sci-Fi',10778:'Tv',
    53:'Thriller',10752:'War',37:'Western'
  }

//fpr local storage
 useEffect(()=>{
 let oldFav=localStorage.getItem("moviemania");
          oldFav=JSON.parse(oldFav)||[]; 
          // ||[]
          console.log(oldFav);
          setfavourites(oldFav)
          
 },[])
//for genres
useEffect(()=>{
  let temp=favourites.map((movie)=>genreids[movie.genre_ids[0]])
  temp = new Set(temp)
  setGenres(["All Genres",...temp]);
},[favourites])

let del=(movie)=>{
    let newArray =favourites.filter((m)=>m.id!=movie.id)
    setfavourites([...newArray])
    localStorage.setItem("moviemania",JSON.stringify(newArray))
  }
//filtering
 let filteredMovies=[]
 filteredMovies = curGenre=="All Genres" ? favourites :
 favourites.filter((movie)=>genreids[movie.genre_ids[0]] == curGenre)

//searching
filteredMovies=filteredMovies.filter((movie)=>
movie.title.toLowerCase().includes(search.toLowerCase())
)

//Sorting
if(rating==1){
  filteredMovies = filteredMovies.sort(function(objA,objB){
    return objA.vote_average - objB.vote_average
  })
}
else if(rating==-1){
  filteredMovies = filteredMovies.sort(function(objA,objB){
    return objB.vote_average - objA.vote_average
  })
}
if(popularity==1){
  filteredMovies = filteredMovies.sort(function(objA,objB){
    return objA.popularity - objB.popularity
  })
}
else if(popularity==-1){
  filteredMovies = filteredMovies.sort(function(objA,objB){
    return objB.popularity - objA.popularity
  })
}

//paging
let maxPage =Math.ceil(filteredMovies.length/rows)
let si=(curpage-1)*rows
let ei=Number(si)+Number(rows)
filteredMovies =filteredMovies.slice(si,ei); 

let goback = ()=>{
  if(curpage>1){
    setCurpage(curpage-1)
  }
}
let goahead = ()=>{
  if(curpage<maxPage){
    setCurpage(curpage+1)
  }
}


 let detailadd =(movie)=>{
    let detarray =[movie]
    setdetail([movie])
    localStorage.setItem("singleMovie",JSON.stringify(detarray))
    console.log([detarray])
  }




  return (
    <>
     <div className=" my-2 flex justify-center flex-wrap space-x-2">
       {
          genres.map((genre)=>
          
          
           <button className=
        {
         curGenre== genre ?
          "text-xl p-2 px-2 font-bold bg-stone-700 opacity-90 rounded-xl"
          :
          "text-xl p-2 px-2 font-bold bg-yellow-400 hover:bg-stone-700 opacity-90 rounded-xl"
        }
        onClick={()=>{
          setCurpage(1)
          setcurGenre(genre)}}
        
        >
          {genre}
        </button>
          )

       }
      </div>
     <div className="text-center">
        <input
          type="text"
          value={search} onChange={(e)=>setSearch(e.target.value)}
          placeholder="Search"
          className="border border-4 text-center p-1 m-2"
        />
        <input
          type="number"
          placeholder="Rows"
          value={rows} onChange={(e)=>setRows(e.target.value)}
          className="border border-4 text-center p-1 m-2"
        />
            <div className="flex flex-col m-4">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  > <div className="flex">
                    <img src="https://img.icons8.com/external-those-icons-lineal-those-icons/24/000000/external-up-arrows-those-icons-lineal-those-icons-3.png"
                     className="mr-2 cursor-pointer"
                    onClick={()=>{setRatng(+1)
                    setPopularity(0)
                    }}
                     /> 
                    Rating 
                     <img src="https://img.icons8.com/external-those-icons-lineal-those-icons/24/000000/external-down-arrows-those-icons-lineal-those-icons-4.png"
                      className="ml-2 cursor-pointer"
                     onClick={()=>{setRatng(-1)
                    setPopularity(0)
                    }}                    
                      />
                      </div>
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    <div className="flex">
                    <img src="https://img.icons8.com/external-those-icons-lineal-those-icons/24/000000/external-up-arrows-those-icons-lineal-those-icons-3.png"
                     className="mr-2 cursor-pointer"
                     onClick={()=>{setPopularity(+1)
                    setRatng(0)
                    }}
                     /> 
                    Popularity 
                     <img src="https://img.icons8.com/external-those-icons-lineal-those-icons/24/000000/external-down-arrows-those-icons-lineal-those-icons-4.png"
                      className="ml-2 cursor-pointer"
                      onClick={()=>{setPopularity(-1)
                    setRatng(0)
                      }}
                      />
                      </div>
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Genre
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                 {filteredMovies.map((movie)=>(
                  <tr key={movie.id}>
                  
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <Link to="/Detail" className="flex-shrink-0 md:h-[100px] md:w-[150px] "
                         onClick={()=>detailadd(movie)}
                        >
                          <img className="hidden md:block md:h-[100px] md:w-[150px]" 
                          src={`https://image.tmdb.org/t/p/w500/${movie.backdrop_path}`}
                          
                           />
                        </Link>
                        <Link to="/Detail" className="ml-4">
                          <div className="text-sm font-medium text-gray-900"
                          onClick={()=>detailadd(movie)}
                          >
                            {movie.title}
                          </div>
            
                        </Link>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      
                      <div className="text-sm text-black-500 px-10">
                        {movie.vote_average}
                        </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm px-8 text-black-500">
                        {movie.popularity}
                        </div>
                      
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    
                    
                     
                      <span className="p-2 inline-flex text-lg leading-5
                      font-semibold rounded-full bg-gray-400 text-white
                      ">
                        {genreids[movie.genre_ids[0]]}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button className="bg-red-300 p-3 rounded-xl text-lg font-bold hover:text-red-700"
                    onClick={()=>del(movie)}
                      >Delete</button>
                    </td>
                  </tr>
                 ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
        </div>
    
    
    <Paging pageprop={curpage} goBack={goback} goNext={goahead}/>
    
    </>
  )
}

export default Favourites